import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CollectionLocationActivity from "../CollectionLocationActivity";
import ModelProxyClass from "./ModelProxyClass";
import Location from "../Location";
import CashCollection from "../CashCollection";
import CashTransfer from "../CashTransfer";


/**
 * @class CollectionLocationActivityBase
 * @extends ModelBaseClass
 * @property {string} key a unique identifier within all items within this array that can be used for index purposes
 * @property {Location} location
 * @property {Date} dateGamingDay (date only)
 * @property {[CashCollection]} cashCollections
 * @property {[CashTransfer]} cashTransfers only for RT Fills that were performed in this location on this day
 * @property {number} subtotalAmountFills
 * @property {number} subtotalAmountVgtDrops
 * @property {number} subtotalEmergencyRamClearVgtDropCount (integer)
 * @property {number} subtotalAmountBvDrops
 * @property {number} subtotalAmountRtAudits
 */
class CollectionLocationActivityBase extends ModelBaseClass {
	/**
	 * a unique identifier within all items within this array that can be used for index purposes
	 * @type {string} key
	 */
	key;
	/**
	 * @type {Location} location
	 */
	location;
	/**
	 * @type {Date} dateGamingDay (date only)
	 */
	dateGamingDay;
	/**
	 * @type {[CashCollection]} cashCollections
	 */
	cashCollections;
	/**
	 * only for RT Fills that were performed in this location on this day
	 * @type {[CashTransfer]} cashTransfers
	 */
	cashTransfers;
	/**
	 * @type {number} subtotalAmountFills
	 */
	subtotalAmountFills;
	/**
	 * @type {number} subtotalAmountVgtDrops
	 */
	subtotalAmountVgtDrops;
	/**
	 * @type {number} subtotalEmergencyRamClearVgtDropCount (integer)
	 */
	subtotalEmergencyRamClearVgtDropCount;
	/**
	 * @type {number} subtotalAmountBvDrops
	 */
	subtotalAmountBvDrops;
	/**
	 * @type {number} subtotalAmountRtAudits
	 */
	subtotalAmountRtAudits;

	/**
	 * Instantiates a new instance of CollectionLocationActivity based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CollectionLocationActivity}
	 */
	static create(genericObject) {
		const newCollectionLocationActivity = new CollectionLocationActivity();
		newCollectionLocationActivity.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCollectionLocationActivity;
	}

	/**
	 * Instantiates a new array of CollectionLocationActivity based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CollectionLocationActivity]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCollectionLocationActivityArray = [];
		genericArray.forEach(genericObject => {
			newCollectionLocationActivityArray.push(CollectionLocationActivity.create(genericObject));
		});
		return newCollectionLocationActivityArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('key', 'string'),
	ModelBaseClass.createModelProperty('location', 'Location'),
	ModelBaseClass.createModelProperty('dateGamingDay', 'datetime'),
	ModelBaseClass.createModelProperty('cashCollections', '[CashCollection]'),
	ModelBaseClass.createModelProperty('cashTransfers', '[CashTransfer]'),
	ModelBaseClass.createModelProperty('subtotalAmountFills', 'float'),
	ModelBaseClass.createModelProperty('subtotalAmountVgtDrops', 'float'),
	ModelBaseClass.createModelProperty('subtotalEmergencyRamClearVgtDropCount', 'integer'),
	ModelBaseClass.createModelProperty('subtotalAmountBvDrops', 'float'),
	ModelBaseClass.createModelProperty('subtotalAmountRtAudits', 'float'),
];

export default CollectionLocationActivityBase;
